import { tryUntil } from 'common';
import { List } from 'react-virtualized';

const getScrollYFromElementOrWindow = (el: HTMLElement | typeof window): number =>
  (el as HTMLElement)?.scrollTop || (el as typeof window).scrollY || 0;

export const scrollToPosition = (scrollTop: number, callback?: () => boolean): void => {
  tryUntil(
    () => {
      const scrollEl = window;
      if (scrollEl) {
        scrollEl.scrollTo({ top: scrollTop, behavior: 'auto' });
        const updatedScrollTop = getScrollYFromElementOrWindow(scrollEl);

        //console.log('scrolling to...', scrollTop, 'from...', updatedScrollTop);

        return updatedScrollTop === scrollTop;
      }
      // Try next
      return false;
    },
    5,
    0,
    (isSuccessful: boolean) => {
      if (isSuccessful && callback) tryUntil(callback, 2, 0);
    }
  );
};

export const scrollToRow = (index?: number | undefined, ref?: List): void => {
  if (index === undefined || ref === undefined) return;
  const scrollTop = ref.getOffsetForRow({ index, alignment: 'center' });
  ref.scrollToPosition(scrollTop);
};

export const overrideListScrollTo = (list: List, callback?: () => boolean): void => {
  list.scrollToPosition = (scrollTop: number) => scrollToPosition(scrollTop, callback);
  list.scrollToRow = (index: number) => scrollToRow(index, list);
};
